import { useBridgeScannerFiltersStore } from "@/features/bridge-scanner/stores/filters.store";
import { BSFilterParamEnum } from "@/types/bridge-scanner.types";
import dayjs from "dayjs";
import { useParams, useRouter } from "next/navigation";

export const useFilterApply = () => {
  const { queryParams, dateRange } = useBridgeScannerFiltersStore();
  const { network } = useParams() as { network: string };

  const router = useRouter();

  const handleApplyParams = () => {
    const url = new URLSearchParams();

    // Append other query parameters from `queryParams`
    queryParams.forEach((values, key) => {
      if (values.length > 0) {
        url.append(key, values.join(",")); // Preserve filtering logic
      }
    });

    // Append date range parameters if available
    if (dateRange[0])
      url.append(
        BSFilterParamEnum.FromDate,
        dayjs(dateRange[0]).unix().toString(),
      );
    if (dateRange[1])
      url.append(
        BSFilterParamEnum.ToDate,
        dayjs(dateRange[1]).unix().toString(),
      );

    // Construct a RESTful URL using path parameters
    router.replace(`/bridge-scanner/${network}?${url.toString()}`, {
      scroll: false,
    });
  };

  const resetURLFilterParams = () => {
    router.replace(`/bridge-scanner/${network}`, { scroll: false });
  };

  return {
    handleApplyParams,
    resetURLFilterParams,
  };
};
